import TESTING_INSTALLATION_IDS from '@/utils/constants/testingInstallationIds';

export default (installationId) => TESTING_INSTALLATION_IDS.includes(installationId);
